import type { AutoStance } from "./types";

// The auto stances (2026-10-08: "add auto stances: none, aware, all. none
// and all are current off and on. aware only attacks enemies that can see
// us/know of us"). The server has the rule (internal/game/autostance.go);
// this is only what the control and the panel say about it.

/** In the order the control steps through them, the quietest first. */
export const AUTO_STANCES: readonly AutoStance[] = ["none", "aware", "all"];

/** The auto stance a press of the control asks for: the next one round. */
export function nextAutoStance(st: AutoStance): AutoStance {
  return AUTO_STANCES[(AUTO_STANCES.indexOf(st) + 1) % AUTO_STANCES.length];
}

/** The word on the control. */
export function autoWord(st: AutoStance): string {
  return `Auto: ${st}`;
}

/** What an auto stance swings at, in a sentence of its own. */
export function autoMeaning(st: AutoStance): string {
  switch (st) {
    case "none":
      return "Auto: none. You only ever hit the target you pick; standing beside a monster does not start on it.";
    case "aware":
      return "Auto: aware. You swing only at monsters in reach that know you are there: hunting or fighting you, traded a swing with you in the last ten seconds, or close enough to notice you. The rest are left alone.";
  }
  return "Auto: all. You swing at any monster in reach that you did not pick, those that know you are there first.";
}

/** The control's hover: what the auto stance is and what a press changes it to. */
export function autoTitle(st: AutoStance): string {
  return `${autoMeaning(st)} Click for ${nextAutoStance(st)}.`;
}
